import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import { getMapKey, isStringEmpty } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import ImageTile from "@/components/TilesModule/variants/TilesManagement/ImageTile"
import RestTile from "@/components/TilesModule/variants/TilesManagement/RestTile"
import { useState } from "react"
import { getLinkData } from "@/components/common/Links/utils"
import { useRouter } from "next/router"
import { useIsMobile } from "@/hooks/useDevice"
import Tile from "@/components/TilesModule/variants/TilesManagement/Tile"

export default function TilesManagement({ data, paddings, headerDescription }) {
	const isMobile = useIsMobile()
	const router = useRouter()
	const id = data?.id || ""
	const tiles = data?.tiles || []
	const link = getLinkData(data?.lastTileLink)
	const isTwoItemsVariant = tiles.length === 2
	const indent = isTwoItemsVariant ? 4 : 1

	const [isLastElementHovered, setIsLastElementHovered] = useState(false)

	const handleHoverElement = (index) => {
		if (index === tiles.length - 1) {
			setIsLastElementHovered(true)
		} else {
			setIsLastElementHovered(false)
		}
	}

	const handleClickLastElement = () => {
		if (!isLastElementHovered || isStringEmpty(link.url)) return
		router.push(link.url)
	}

	return (
		<section id={id} className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			{isMobile ? (
				<GridContainer>
					{tiles.map((tile, index) => (
						<Tile
							key={getMapKey(tile, index)}
							data={tile}
							index={index}
							isLastTile={index === 2}
							isLastElementHovered={isLastElementHovered}
							handleHoverElement={handleHoverElement}
							handleClickLastElement={handleClickLastElement}
						/>
					))}
				</GridContainer>
			) : (
				<>
					<GridContainer className={`indent-desktop-${indent}`}>
						{tiles.map((tile, index) => (
							<ImageTile
								key={getMapKey(tile, index)}
								data={tile}
								index={index}
								isLastTile={index === 2}
								isLastElementHovered={isLastElementHovered}
								handleHoverElement={handleHoverElement}
								handleClickLastElement={handleClickLastElement}
							/>
						))}
					</GridContainer>
					<GridContainer className={`indent-desktop-${indent}`}>
						{tiles.map((tile, index) => (
							<RestTile
								key={getMapKey(tile, index)}
								data={tile}
								index={index}
								isLastTile={index === 2}
								isLastElementHovered={isLastElementHovered}
								handleHoverElement={handleHoverElement}
								handleClickLastElement={handleClickLastElement}
							/>
						))}
					</GridContainer>
				</>
			)}
		</section>
	)
}
